import { FoodfluenceLocation, Campaign, Collab } from '@foodfluence/shared';
import { getClientIdFromCollabRequest } from 'utils/collabUtils';
import { CollabFormValues } from './types';

export const SINGLE_CLIENT_COLLAB_REQUEST_LIMIT = 2;


export const findExistingCollabRequest = (
  campaign: Campaign | null,
  collabData: Collab[]
): Collab | null => {
  if (!campaign) return null;
  return collabData.find(collab => collab.influencerCampaignID === campaign.id) || null;
};
export const getPendingCollabRequestsForClient = (
  collabData: Collab[],
  campaigns: Record<string, Campaign>,
  client: { id: string } | null
): Collab[] => {
  return collabData.filter(collab => 
    collab.status === 'pendingClientApproval' &&    
    getClientIdFromCollabRequest(collab, campaigns?.[collab.id]) === client?.id
  );
};

export const hasCollabChanges = (
  values: CollabFormValues,
  requestedCollab: Collab | null,
  isCustomRequest: boolean
): boolean => {
  if (!requestedCollab) return true;

  const currentDeliverables = {
    tiktoks: values.tikTokCount,
    instagramReels: values.igReelCount,
    instagramPosts: values.igPostCount,
    instagramStories: values.igStoryCount
  };

  const originalDeliverables = requestedCollab.proposedInfluencerDeliverableCounts || {};
  
  return (
    currentDeliverables.tiktoks !== (originalDeliverables.tiktoks || 0) ||
    currentDeliverables.instagramReels !== (originalDeliverables.instagramReels || 0) ||
    currentDeliverables.instagramPosts !== (originalDeliverables.instagramPosts || 0) ||
    currentDeliverables.instagramStories !== (originalDeliverables.instagramStories || 0) ||
    values.cashAmount !== (requestedCollab.proposedInfluencerCash || 0) ||
    values.creditAmount !== (requestedCollab.proposedInfluencerCredit || 0) ||
    (isCustomRequest && values.note !== (requestedCollab.influencerNote || '')) ||
    (isCustomRequest && values.campaignType !== requestedCollab.customCollabType)
  );
};

export const isCollabValid = (
  values: CollabFormValues,
  requestedCollab: Collab | null,
  pendingRequestsCount: number,
): boolean => {
  return (((!requestedCollab && pendingRequestsCount < SINGLE_CLIENT_COLLAB_REQUEST_LIMIT) || requestedCollab) && 
    (values.tikTokCount > 0 ||
    values.igReelCount > 0 ||
    values.igPostCount > 0 ||
    values.igStoryCount > 0) &&
    (values.cashAmount > 0 || values.creditAmount > 0 || values.campaignType === 'shipToHome')
  );
};
